import qs from "qs";
var path = require("path");
var baseUrl = "/bk35/v1/";
var key = "fits0800666811fits";
var headers = {
    'content-type': 'application/json',
    'x-api-key': key
}

export default {
    data() {
        return {}
    },
    methods: {
        apiAddItem(body = "") {
            var url = path.join(baseUrl, "additem");
            return this.$http.post(url, body, { headers: headers });
        },
        apiUpdItem(body = "") {
            var url = path.join(baseUrl, "upditem");
            return this.$http.post(url, body, { headers: headers });
        },
        apiGetOrdertmp() {
            var url = path.join(baseUrl, "ordertmp");
            return this.$http.get(url, { headers: headers });
        },
        apiCallService(body) {
            var url = path.join(baseUrl, "call-bell");
            return this.$http.post(url, body, { headers: headers });
        },
        apiSendOrdertmp(body) {
            var url = path.join(baseUrl, "send-ordertmp");
            return this.$http.post(url, body, { headers: headers });
        },
        apiGetOCheck(query = "") {
            var url = path.join(baseUrl, "ocheck") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiGetMenus(query = "") {
            var url = path.join(baseUrl, "mpo-menus") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiGetItemC(query = "") {
            var url = path.join(baseUrl, "mpo-itemc") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiGetConfig(query = "") {
            var url = path.join(baseUrl, "config") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiGetEaterPo(query = "") {
            var url = path.join(baseUrl, "eater-po") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiGetStopSale(query = "") {
            var url = path.join(baseUrl, "stop-sale") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiCheckPassCode(query = "") {
            var url = path.join(baseUrl, "check-passcode") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        }

    },
};